<template>
	<div class="row">
		<ListingHeader :title="currentCategory.category" :savings="categorySavings" />
		<CategorySidebar class="offset-md-1"/>

		<div class="col-12 col-md-8" v-if="categories" id="subcategoryList">
			<div class="row">
				<div class="col-12 order-md-last">
					<div class="row">
						<div class="col-12">
						<div class="row">
							<h2 class="col-12">Subcategories</h2>
							<CategoryItem v-for="(category, index) in subcategories" :key="index" :item="category"/>
						</div>
						</div>
					</div>
				</div>
				<!-- Must not start with number or slugs don't work -->
				<PromoTile class="promoTile" :name="'id-' + currentCategory.id + '-above-specials'"/>
				<div v-if="specials && specials.length > 0" class="col-12 productSpecials">
					<div class="row my-2">
						<h2 class="col-12">{{currentCategory.category}} Specials</h2>
						<ProductCarousel :items="specials" :key="$route.params.category"/>
					</div>

				</div>
			</div>
		</div>
		<vue-headful
			:title="'Shop ' + (currentCategory && currentCategory.category ? currentCategory.category + ' | Cherrytree' : 'Cherrytree')"
			:description="currentCategory.category"
		/>
	</div>
</template>

<script>
import CategoryItem from "./CategoryItem";
import CategorySidebar from "./CategorySidebar";
import PromoTile from '@/components/promoTile/PromoTile'
// import Breadcrumbs from "@/components/breadcrumbs/Breadcrumbs";
import { mapState } from "vuex";

import ProductCarousel from "@/components/productCarousel/productCarousel";
import { fetchSpecials } from "@/network/listingRequests";
import { fetchCatSavings } from "@/network/categoryRequests";

import ListingHeader from "@/sections/shop/listing/ListingHeader";

export default {
	name: "CategoryListing",
	components: {
		CategoryItem,
		CategorySidebar,
		ProductCarousel,
		PromoTile,
		// Breadcrumbs,
		ListingHeader
	},
	data() {
		return {
			specials: null,
			savings: null
		};
	},
	created() {
		const params = { categoryId: this.$route.params.category };
		fetchSpecials(params, specials => {
			this.specials = specials;
		});
		fetchCatSavings(
			this.$route.params.category,
			res => {
				this.savings = res;
			}
		)
	},
	computed: {
		...mapState({
			// map categories to store.reference.categories
			categories: state => state.reference.categories
		}),
		currentCategory() {
			let catId = this.$route.params.category;
			if (!catId || !this.categories) return "";
			return this.categories[catId];
		},
		subcategories() {
			let catId = this.$route.params.category;
			if (!catId || !this.categories) return [];
			let subcats = this.categories[catId].children;

			let sorted = Object.values(subcats).sort((a,b) => {
				return a.category.localeCompare(b.category)
			})

			return sorted;
		},
		categorySavings() {
			let savingsString = "";
			if (this.savings != null && this.savings.max_saving != null && this.savings.min_saving != null) {
				savingsString = "Gold Members save between " + this.savings.min_saving + " and " + this.savings.max_saving + "%";
			}
			return savingsString
		}
	}
};
</script>

<style lang="scss">
// sidebar styles are set in the sidebar.scss file in styles folder, changes will affect all sidebars
	@include media-breakpoint-down(md){
		.productSpecials{
			padding: 30px 15px;
		}
		.promoTile{
			padding: 40px 0 20px;
		}
	}
	
</style>
